// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iIYx","top":"styles_top__19-70","left":"styles_left__iCru5","description":"styles_description__LIq3O"};